import { Button } from "antd";
import { Link } from "react-router";
import Worker from "../../../assets/images/platform/maintenance-repair-works.svg";
// import BGLeft from "../_icons/platform-bg-left.svg";
// import BGRight from "../_icons/platform-bg-right.svg";

export default function Platform() {
  return (
    <section className="bg-white pt-28 lg:pt-44 relative">
      {/* MAIN CONTAINER */}
      <div className="container mini-container relative">
        <div className="relative bg-theme-yellow-400 rounded-3xl grid grid-cols-12 items-center px-8 lg:px-16 z-10 -mb-24 gap-4">
          {/* LEFT CONTENT */}
          <div className="col-span-12 lg:col-span-7 z-10 pt-12 pb-8 lg:pt-0 lg:pb-0">
            <div className="justify-start text-black text-3xl lg:text-5xl font-medium">
              এক প্ল্যাটফর্মেই
              <br />
              কোর্স + চাকরি + সাফল্য
            </div>

            <div className="self-stretch justify-start text-black text-base font-normal mt-2">
              আজই প্রশিক্ষণ নিন, দক্ষতা বাড়ান —<br />
              দেশে বা বিদেশে ভালো চাকরির সুযোগ পান।
            </div>

            {/* BUTTONS */}
            <div className="mt-6 flex flex-wrap gap-4">
              <Link to="/jobs">
                <Button
                  type="default"
                  className="px-6 py-3 rounded-full bg-theme-black border border-theme-black !text-theme-white-900 font-medium 
                hover:!bg-theme-black hover:!border-theme-black text-sm lg:text-base"
                >
                  এখনই চাকরি খুঁজুন
                </Button>
              </Link>

              <Link to="/courses">
                <Button
                  type="default"
                  className="px-6 py-3 rounded-full bg-theme-red-500 border border-theme-red-500 !text-theme-white-900 font-medium 
                hover:!bg-theme-red-500 hover:!border-theme-red-500 text-sm lg:text-base"
                >
                  সব কোর্স দেখুন
                </Button>
              </Link>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className=" col-span-12 lg:col-span-5 z-10 flex justify-center lg:justify-end">
            <img
              src={Worker}
              alt="Worker"
              className="w-[458px]  lg:h-96 xl:h-96 lg:-mt-24 hidden lg:block"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
